import { Notification } from '@thanx/uikit/notification'
import { Switch } from '@thanx/uikit/switch'
import { Button } from 'react-bootstrap'

import FlagIcon from 'components/FlagIcon'
import Spinner from 'components/Spinner'
import useModifiers from 'hooks/useModifiers'
import { useShowMore } from 'hooks/useShowMore'
import { buildTranslate } from 'locales'
import ModifierItem from './Item'

const t = buildTranslate('redeem_manager.detail.cards.online_redemption')

type ModifierListProps = {
  modifierIds: string[]
  productIds: string[]
}

const ModifierList = ({ modifierIds, productIds }: ModifierListProps) => {
  const { modifiers, isLoading, isReady, error } = useModifiers({
    item_ids: productIds,
    option_ids: modifierIds,
  })

  const {
    visibleItems: visibleModifierIds,
    hiddenCount,
    hasHidableItems,
    toggleShowAll,
    showAll,
  } = useShowMore(modifierIds)

  if (isLoading) {
    return <Spinner isLoading className="text-center margin-top-huge" />
  }

  const modifiersAreAvailable = modifierIds.some(modifierId =>
    Boolean(
      modifiers.find(modifier => modifier.option.chain_uid === modifierId)
    )
  )

  const modifierItems = visibleModifierIds.map(id => {
    const modifier = modifiers.find(
      modifier => modifier.option.chain_uid === id
    )
    if (!modifier) return null
    return (
      <ModifierItem
        key={modifier.option.chain_uid}
        modifier={modifier}
        productIds={productIds}
        canDelete={false}
        isViewMode
      />
    )
  })

  return (
    <div>
      <Switch
        condition={isReady && !error && modifiersAreAvailable}
        fallback={
          <>
            <p>{modifierIds.join(', ')}</p>
            <Notification kind="warning" size="full">
              <FlagIcon color="#e7b41a" />
              <span className="ml-xs body-text-4">
                {t('modifiers_not_available')}
              </span>
            </Notification>
          </>
        }
      >
        {modifierItems}
        <Switch condition={hasHidableItems}>
          <Button bsStyle="link" type="button" onClick={toggleShowAll}>
            {showAll ? t('show_less') : t('show_more', { count: hiddenCount })}
          </Button>
        </Switch>
      </Switch>
    </div>
  )
}

export default ModifierList
